import { AfterViewInit, Component, ElementRef, EventEmitter, input, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import * as _ from 'lodash';

@Component({
    selector: 'app-litmus-dropdown',
    templateUrl: './litmus-dropdown.component.html',
    styleUrls: ['./litmus-dropdown.component.scss'],
    standalone: false
})
export class LitmusDropdownComponent implements OnInit,OnChanges,AfterViewInit {
  @ViewChild('litmscustomdropdown') litmscustomdropdown!:ElementRef;
  @Output() change:any = new EventEmitter<any>()
  @Input() props:any = {};
  @Input() selectedOption: any = {};
  @Input() value:any=null;
  @Input() disabled:boolean = false;
  @Input() readonly:boolean = false;
  isOpen = false;
  options: any = []
  groupBy: string = ''
  preffix: string = ''
  categorization: boolean = false
  list: any[] = []
  sourceList: any = []
  placeholder: string = "Select one";
  ddButton: any;
  ddMenu: any;
  listner:any;

  constructor(){}
  ngOnInit(): void {
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.props = (typeof this.props == 'string')?JSON.parse(this.props):this.props;
    this.selectedOption = (typeof this.selectedOption == 'string')?JSON.parse(this.selectedOption):this.selectedOption;
    this.value = (this.selectedOption && this.selectedOption.value)?this.selectedOption.value:null;
    this.initOptions(this.props);
  }
  ngAfterViewInit(): void {
    document.addEventListener('click', ( event )=>{
      if (this.litmscustomdropdown && this.litmscustomdropdown.nativeElement !== event.target &&  !this.litmscustomdropdown.nativeElement.contains(event.target)) {  
        this.isOpen = false
      }
    });
  }

  initOptions(config: any) {
    this.groupBy = _.get(config, 'groupBy', '');
    this.preffix = _.get(config, 'preffix', '');
    this.categorization = _.get(config, 'categorization', false);
    this.placeholder = _.get(config, 'placeholder', this.placeholder);
    this.options = _.get(config, 'options', []);
    if (this.options.length > 0) {
      if (this.categorization) {
        this.list = this.prepareOptionsByCategory(this.options, this.groupBy);
        this.sourceList = Helpers.deepClone(this.list);
      } else {
        this.list = this.options;
        this.sourceList = Helpers.deepClone(this.options);
      }
    }
  }

  prepareOptionsByCategory(list: any, field: string) {
    const temp_list = _.groupBy(list, field)
    let categoriesed_list: any[] = []
    _.each(temp_list, (value: any, key: string) => {
      categoriesed_list.push({
        category_name: key.charAt(0).toUpperCase() + key.slice(1),
        options: _.filter(value, (object: any) => {
          if (!_.isEmpty(object.name)) {
            return object
          }

        })
      })
    })
    return categoriesed_list
  }

  openDropDown(event: any) {
    event.preventDefault()
    this.isOpen = true;
    setTimeout(() => {
      document.getElementById("litmus-dropdown-search")?.focus()
    }, 0);
  }

  filterList(event: any) {
    event.stopPropagation();
    const text = _.get(event, 'target.value', '').toLowerCase();
    if (text && text != "") {
      if (this.categorization) {
        this.list = _.filter(Helpers.deepClone(this.sourceList), (category: any) => {
          category.options = _.filter(category.options, (option: any) => {
            return (option.name && option.name.toLowerCase().indexOf(text) >= 0)
          })
          if (category.options && category.options.length) {
            return true
          } else {
            return false
          }
        })
      } else {
        this.list = _.filter(Helpers.deepClone(this.sourceList), (option: any) => {
          return (option.name && option.name.toLowerCase().indexOf(text) >= 0)
        })
      }
    } else {
      this.list = Helpers.deepClone(this.sourceList)
    }
  }

  selectOption(event: any, option: any) {
    event.stopPropagation()
    this.selectedOption = option;
    this.value = option.value
    this.change.emit(option);
    this.isOpen = false
  }
}
